/**
 * @generated SignedSource<<7efcc4cd384e410fb7eb63940bbfe181>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RecordCompanyVideoButton_Query$variables = {
  firmId: string;
};
export type RecordCompanyVideoButton_Query$data = {
  readonly configuration: {
    readonly videoMaxDurationCompany: number | null | undefined;
    readonly videoMinDuration: number | null | undefined;
  } | null | undefined;
  readonly firm: {
    readonly " $fragmentSpreads": FragmentRefs<"RecordCompanyVideoButton_Firm">;
  } | null | undefined;
};
export type RecordCompanyVideoButton_Query = {
  response: RecordCompanyVideoButton_Query$data;
  variables: RecordCompanyVideoButton_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "firmId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "firmId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "Configuration",
  "kind": "LinkedField",
  "name": "configuration",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "videoMaxDurationCompany",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "videoMinDuration",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rawId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RecordCompanyVideoButton_Query",
    "selections": [
      {
        "alias": "firm",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "RecordCompanyVideoButton_Firm"
          }
        ],
        "storageKey": null
      },
      (v2/*: any*/)
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RecordCompanyVideoButton_Query",
    "selections": [
      {
        "alias": "firm",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "self",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Video",
                "kind": "LinkedField",
                "name": "video",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "Firm",
            "abstractKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      },
      (v2/*: any*/)
    ]
  },
  "params": {
    "cacheID": "ee8302f1c3a3d7d0d723be348ef07b2f",
    "id": null,
    "metadata": {},
    "name": "RecordCompanyVideoButton_Query",
    "operationKind": "query",
    "text": "query RecordCompanyVideoButton_Query(\n  $firmId: ID!\n) {\n  firm: node(id: $firmId) {\n    __typename\n    ...RecordCompanyVideoButton_Firm\n    id\n  }\n  configuration {\n    videoMaxDurationCompany\n    videoMinDuration\n  }\n}\n\nfragment RecordCompanyVideoButton_Firm on Firm {\n  rawId\n  self\n  video {\n    rawId\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "cf82bba60b8d5365c596a62924a6d150";

export default node;
